import React from 'react';
import { css } from 'styled-components';
import { Container, MaxWidth } from '../../common/base';
import { Grid, Col } from '../../common/interfaces';
import Button from '../../common/components/basic/Button';
import Link from '../../common/components/basic/Link';
import useTheme from '../../common/utils/styles/theme/useTheme';

export default function BottomCTA({
  topColor: _topColor = undefined,
  bottomColor: _bottomColor = undefined,
  title,
  description = undefined,
  ctaText,
  href
}) {
  const { colors } = useTheme();
  const topColor = _topColor || 'transparent';
  const bottomColor = _bottomColor || colors.primary.secondary;
  return (
    <div
      css={css`
        background-color: ${topColor};
        position: relative;
        white-space: pre-wrap;
        &:before {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 50%;
          content: '';
          background-color: ${bottomColor};
        }
      `}
    >
      <Container>
        <div
          css={css`
            background-color: ${({ theme: { colors } }) => colors.light.primary};
            padding: 80px 100px;
            border-radius: 4px;
            ${MaxWidth.md`
              padding: 80px 40px;
            `}
            ${MaxWidth.sm`
              padding: 40px 24px;
            `}
          `}
        >
          <Grid align="center">
            <Col lg={8} md={12}>
              <h2>{title}</h2>
              <p>{description}</p>
            </Col>
            <Col lg={4} md={12}>
              <div
                css={css`
                  display: flex;
                  justify-content: flex-end;
                `}
              >
                <div>
                  <Link href={href}>
                    <a target="_blank">
                      <Button>{ctaText}</Button>
                    </a>
                  </Link>
                </div>
              </div>
            </Col>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
